module.exports = __webpack_public_path__ + "media/Video 23.c3d90b52.mp4";